import React from 'react';
import { fmtCents } from '../../lib/financial';

// Sprint I C6 — payment schedule on Admin + Portal invoice detail.
//
// Props:
//   schedule  — array of { id, expected_date, expected_amount_cents, status,
//               fulfilled_payment_id, notes }
export default function PaymentSchedulePanel({ schedule = [], currency = 'USD' }) {
  if (!schedule || schedule.length === 0) return null;
  return (
    <div data-testid="payment-schedule" className="rounded-2xl border border-white/[0.05] bg-white/[0.015] p-5">
      <h3 className="text-[13px] font-semibold text-white mb-3">Payment schedule</h3>
      <ul className="space-y-2 text-[13px]">
        {schedule.map((s) => {
          const paid = !!s.fulfilled_payment_id;
          return (
            <li key={s.id} className="flex items-center justify-between gap-3 px-3 py-2 rounded-lg border border-white/[0.06] bg-white/[0.02]">
              <div className="text-gray-300">
                <span className="font-mono text-[11px] text-gray-500 mr-2">{(s.expected_date || '').slice(0, 10)}</span>
                <span>{s.notes || 'Scheduled payment'}</span>
              </div>
              <div className="flex items-center gap-2">
                <span className="text-white">{fmtCents(s.expected_amount_cents, currency)}</span>
                {paid && <span className="text-[10px] uppercase tracking-wider text-emerald-300">Paid</span>}
                {!paid && s.status === 'overdue' && <span className="text-[10px] uppercase tracking-wider text-red-300">Overdue</span>}
              </div>
            </li>
          );
        })}
      </ul>
    </div>
  );
}
